module.exports = __webpack_public_path__ + "static/img/Deliveroo.da62943.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Deliveroo.png
// module id = OYOD
// module chunks = 4